import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { VisibilityWatcher } from "@common/visibilityWatcher";

import { Props, Filter } from "./types";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";

function DateFilter({ selectedFilter, selectFilter }: Props) {
  const { t } = useTranslation();

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={classNames(styles.resourcesFilter, {
            [styles.opened]: isVisible,
          })}
        >
          <div className={styles.input} onClick={isVisible ? hide : show}>
            <p className={styles.selectedResourcesNames}>
              {selectedFilter === "old"
                ? t("documentsPage.reportsPage.filters.oldestReportsFilter")
                : selectedFilter === "new"
                  ? t("documentsPage.reportsPage.filters.newestReportsFilter")
                  : t("documentsPage.reportsPage.filters.newestReportsFilter")}
            </p>
            <ToggleArrow className={styles.toggleArrow} />
          </div>
          {isVisible && (
            <div className={styles.list}>
              <div
                className={styles.item}
                onClick={() => {
                  selectedFilter !== "new" && selectFilter("new");
                  hide();
                }}
              >
                <p className={styles.name}>
                  {t("documentsPage.reportsPage.filters.newestReportsFilter")}
                </p>
              </div>
              <div
                className={styles.item}
                onClick={() => {
                  selectedFilter !== "old" && selectFilter("old");
                  hide();
                }}
              >
                <p className={styles.name}>
                  {t("documentsPage.reportsPage.filters.oldestReportsFilter")}
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export type { Filter };

export { DateFilter };
